module.exports = __webpack_public_path__ + "img/glassquality_4.d709d359.png";